import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { getMaxDepositsCount } from '@/server-actions/payment-methods';

type UseCountsReturn = {
  data: Record<string, number>;
  isLoading: boolean;
  isError: boolean;
};

const useMaxDepositsCounts = (providerIds: string[]): UseCountsReturn => {
  const result: UseQueryResult<Record<string, number>, Error> = useQuery({
    queryKey: ['MAX_DEPOSITS_COUNTS', providerIds],
    queryFn: async (): Promise<Record<string, number>> => {
      // Parallel-fetching each provider’s count
      const results = await Promise.all(providerIds.map((id) => getMaxDepositsCount(id)));
      // Build { [providerId]: count } map
      return providerIds.reduce<Record<string, number>>(
        (acc, id, idx) => {
          acc[id] = results[idx].maxDepositsCount || 0;
          return acc;
        },
        {} as Record<string, number>
      );
    },
    enabled: providerIds.length > 0,
    staleTime: 10 * 60_000,
  });

  return {
    data: result.data ?? {},
    isLoading: result.isLoading,
    isError: result.isError,
  };
};

export default useMaxDepositsCounts;
